module.exports = __webpack_public_path__ + "static/SharpSansNo1-Book-37a4dec080a34e656ad2a675ba7dfe3d.woff";